import { createContext } from 'react';

export const StylesContext = createContext({});
